import React, { Component } from 'react';
class Explain extends Component {
    render() {
        console.log('props', this.props.schema);
        return <pre>{this.props.schema.intro}</pre>
    }
}

export default Explain;